import React from "react";
import { useField } from "formik";
import Switch, { SwitchProps } from "../Switch/Switch";

interface Props extends Partial<SwitchProps> {
  name: string;
}

const FormSwitch = ({ name, ...props }: Props) => {
  const [field, , helpers] = useField(name);

  const onChange = async (checked: boolean) => {
    await helpers.setValue(checked);
    helpers.setTouched(true);
  };

  return (
    <Switch
      id={name}
      name={name}
      toggled={field.value}
      onChange={onChange}
      {...props}
    />
  );
};

export default FormSwitch;
